/**
 * Created by Esteban on 10/27/14.
 */

module media.hrratings.vo {
    export class SearchVO {
        public title: string;
        public uri: string;
    }
}